import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { resetPassword } from "../actions";
import { type MemberProfile } from "../types";
import Component, { type Props } from "./component";
import { makeFieldsSelector } from "./selectors";

const makeMapStateToProps = () => {
  const fieldsSelector = makeFieldsSelector();

  return (state: AppState, props: RootContainerProps): Partial<Props> => {
    return {
      ...props,

      fields: fieldsSelector(state, props)
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): Partial<Props> => ({
  submit: (data: MemberProfile.View.ResetPasswordParams) => dispatch(resetPassword(getEntityRef(props), data.password))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
